"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinishEventTypeSchema = exports.FinishEventType = void 0;
const zod_1 = require("zod");
var FinishEventType;
(function (FinishEventType) {
    FinishEventType["DURATION"] = "DURATION";
    FinishEventType["IDLE_TIMEOUT"] = "IDLE_TIMEOUT";
    FinishEventType["SCREEN_TAP"] = "SCREEN_TAP";
})(FinishEventType || (exports.FinishEventType = FinishEventType = {}));
exports.FinishEventTypeSchema = zod_1.z.nativeEnum(FinishEventType);
